import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import Feedback from 'screens/StrengthDetail/Feedback';
import { selectAddToAgendaState } from 'selectors/addToAgendaStateSelector';
import styled, { css } from 'styled-components';

const FeedbacksList = ({ feedbacks, handleFeedbackAction }) => {
  const { showAddToAgenda } = useSelector(selectAddToAgendaState, shallowEqual);

  return (
    <>
      {feedbacks?.length &&
        feedbacks.map((feedback, index) => (
          <FeedbackContainer $showAddToAgenda={showAddToAgenda}>
            <Feedback key={`feedback-${index}`} data={feedback} showAddToAgenda={showAddToAgenda} />
          </FeedbackContainer>
        ))}
    </>
  );
};

const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 24px 0px 24px;
  position: relative;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
  box-sizing: border-box;
  cursor: default;

  ${(props) =>
    props.$showAddToAgenda &&
    css`
      &:hover {
        z-index: 100;
        box-shadow:
          0 1px 2px 0 ${(props) => props.theme.palette.shadows.card},
          0 2px 6px 2px ${(props) => props.theme.palette.shadows.card};
        background-color: ${(props) => props.theme.palette.background.blue.light.v2};
      }
    `}
`;

export default FeedbacksList;
